import { TriggerButton } from 'components/TriggerButton';
import { TriggerGroupButton } from 'components/TriggerGroupButton';
import { Evaluation } from 'components/activities/common/delivery/evaluation/Evaluation';
import { LikertReportRenderer } from 'components/activities/likert/reports/LikerReportRenderer';
import { DeliveryElementRenderer } from 'components/common/DeliveryElementRenderer';
import { ECLRepl } from 'components/common/ECLRepl';
import { Navbar } from 'components/common/Navbar';
import { SelectTimezone } from 'components/common/SelectTimezone';
import { TechSupportButton } from 'components/common/TechSupportButton';
import { UserAccountMenu } from 'components/common/UserAccountMenu';
import { RichTextEditor } from 'components/content/RichTextEditor';
import { AlternativesPreferenceSelector } from 'components/delivery/AlternativesPreferenceSelector';
import { CourseContentOutline } from 'components/delivery/CourseContentOutline';
import { SurveyControls } from 'components/delivery/SurveyControls';
import { AttemptSelector } from 'components/misc/AttemptSelector';
import { DarkModeSelector } from 'components/misc/DarkModeSelector';
import { PaginationControls } from 'components/misc/PaginationControls';
import { VegaLiteRenderer } from 'components/misc/VegaLiteRenderer';
import { ModalDisplay } from 'components/modal/ModalDisplay';
import { YoutubePlayer } from 'components/youtube_player/YoutubePlayer';
import { registerApplication } from 'apps/app';
import { globalStore } from 'state/store';
import { VideoPlayer } from '../components/video_player/VideoPlayer';
import { OfflineDetector } from './OfflineDetector';
import ActivityBank from './bank/ActivityBank';
import Bibliography from './bibliography/Bibliography';
import { References } from './bibliography/References';

registerApplication('Bibliography', Bibliography, globalStore);
registerApplication('ModalDisplay', ModalDisplay, globalStore);
registerApplication('DarkModeSelector', DarkModeSelector);
registerApplication('PaginationControls', PaginationControls, globalStore);
registerApplication('AttemptSelector', AttemptSelector, globalStore);
registerApplication('SurveyControls', SurveyControls, globalStore);
registerApplication('References', References, globalStore);
registerApplication('VideoPlayer', VideoPlayer);
registerApplication('AlternativesPreferenceSelector', AlternativesPreferenceSelector, globalStore);
registerApplication('Navbar', Navbar, globalStore);
registerApplication('CourseContentOutline', CourseContentOutline, globalStore);
registerApplication('UserAccountMenu', UserAccountMenu, globalStore);
registerApplication('DeliveryElementRenderer', DeliveryElementRenderer, globalStore);
registerApplication('ECLRepl', ECLRepl, globalStore);
registerApplication('SelectTimezone', SelectTimezone, globalStore);
registerApplication('YoutubePlayer', YoutubePlayer, globalStore);
registerApplication('TechSupportButton', TechSupportButton, globalStore);
registerApplication('OfflineDetector', OfflineDetector, globalStore);
registerApplication('RichTextEditor', RichTextEditor, globalStore);
registerApplication('VegaLiteRenderer', VegaLiteRenderer, globalStore);
registerApplication('LikertReportRenderer', LikertReportRenderer, globalStore);
registerApplication('ActivityBank', ActivityBank, globalStore);
registerApplication('Evaluation', Evaluation, globalStore);
registerApplication('TriggerButton', TriggerButton, globalStore);
registerApplication('TriggerGroupButton', TriggerGroupButton, globalStore);
